<app-navigation>
  <!-- content -->
<router-outlet></router-outlet>
<!-- END General content -->

</app-navigation> 